<template>
  <svg v-if="path">
    <defs>
      <marker id="triangle"
              viewBox="0 0 10 10"
              refX="0" refY="5"
              markerUnits="strokeWidth"
              markerWidth="5" markerHeight="4"
              orient="auto">
        <path d="M 0 0 L 10 5 L 0 10 z" :fill="secondColor"/>
      </marker>
    </defs>
    <defs>
      <marker id="triangle2"
              viewBox="0 0 10 10"
              refX="0" refY="5"
              markerUnits="strokeWidth"
              markerWidth="5" markerHeight="4"
              orient="auto">
        <path d="M 0 0 L 10 5 L 0 10 z" :fill="firstColor"/>
      </marker>
    </defs>
    <text v-if="text.length" :x="cx11" :y="cy11" :fill="firstColor" style="font-size: 40px">{{ text }}</text>
    <circle :fill="firstColor" class="spot" :cx="cx1" :cy="cy1" r="2"></circle>
    <path v-if="dL" :d="dL" marker-end='url(#triangle2)'  :stroke="firstColor" stroke-width="2" stroke-dasharray="4" stroke-linecap="round" fill="transparent"></path>
    <path v-if="dK" :d="dK" marker-end='url(#triangle)' :stroke="secondColor" stroke-width="5" stroke-linecap="round" fill="transparent"></path>
  </svg>
</template>
<script>
const POSITION = {
  1: [445, 965],
  2: [275, 965],
  3: [85, 965],
  4: [125, 735],
  5: [125, 475],
  6: [125, 205],
  7: [245, 205],
  8: [445, 205],
  9: [605, 205],
  10: [605, 475],
  11: [605, 705],
  12: [605, 955]
}
export default {
  name: 'LineTuHoa',
  props: {
    index: {
      type: Number,
      default: 0
    },
    path: {
      type: Array,
      default: null
    },
    firstColor: {
      type: String,
      default: 'red'
    },
    secondColor: {
      type: String,
      default: 'red'
    }
  },
  data () {
    return {
      cx1: null,
      cy1: null
    }
  },
  computed: {
    text () {
      let text = ''
      if (this.isLineNien) {
        text += '()'
      }
      if (this.isLineMenh) {
        text += '[]'
      }
      return text
    },
    isLineNien () {
      return this.path[3] && this.path[3].includes(1)
    },
    isLineMenh () {
      return this.path[3] && this.path[3].includes(2)
    },
    cx11 () {
      const [p1] = this.path
      return POSITION[p1][0]
    },
    cy11 () {
      const [p1] = this.path
      return POSITION[p1][1]
    },
    dL () {
      const [p1, p2] = this.path
      if (!p1 || !p2) {
        return null
      }
      return this.getPositions(p1, p2, true)
    },
    dK () {
      const [p1, p2, p3] = this.path
      if (!p2 || !p3) {
        return null
      }
      return this.getPositions(p2, p3, false, p1)
    }
  },
  methods: {
    getPosition (p, index = 0, firstLine = true) {
      return POSITION[p][index] - (this.index + Number(firstLine)) * Math.floor(Math.random() * (6 - 3) + 3)
    },
    getPositions (p1, p2, firstLine) {
      const p1x = this.getPosition(p1, 0, firstLine)
      const p1y = this.getPosition(p1, 1, firstLine)
      const p2x = this.getPosition(p2, 0, firstLine)
      const p2y = this.getPosition(p2, 1, firstLine)

      this.cx1 = p1x
      this.cy1 = p1y

      // console.log(this.index, firstLine, p1x, p1y, p2x, p2y)

      // mid-point of line:
      const mpx = (p2x + p1x) * 0.5
      const mpy = (p2y + p1y) * 0.5

      // angle of perpendicular to line:
      const theta = Math.atan2(p2y - p1y, p2x - p1x) - Math.PI / 2

      // distance of control point from mid-point of line:
      const offset = 50

      // location of control point:
      const c1x = mpx + offset * Math.cos(theta)
      const c1y = mpy + offset * Math.sin(theta)

      // construct the command to draw a quadratic curve
      return 'M' + p1x + ' ' + p1y + ' Q ' + c1x + ' ' + c1y + ' ' + p2x + ' ' + p2y
    }
  }
}
</script>

<style scoped>
  /*svg { background-color: bisque; }*/
</style>
